import { ICellRendererAngularComp, ITooltipAngularComp } from '@ag-grid-community/angular';
import { AfterViewInit, Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageFns, ProxImage } from '@utils';

export interface BlobRendererComponentProps {
  getImage: (item: any) => ProxImage;
  /** Whether the component is being used as a CellRenderer or a TooltipRenderer */
  isTooltip: boolean;
}

@Component({
    selector: 'prox-blob-renderer',
    template: `<div [style]="divStyle"><img [style]="imgStyle" *ngIf="image" [src]="image.safeUrl" /></div>`,
    standalone: false
})
export class BlobRendererComponent implements ICellRendererAngularComp, ITooltipAngularComp, AfterViewInit {
  image!: ProxImage;
  isTooltip!: boolean;
  divStyle = '';
  imgStyle = '';

  constructor(private readonly sanitizer: DomSanitizer) {}

  agInit(params: any): void {
    this.image = params.getImage(params.node?.data ?? params.data);
    this.isTooltip = params.isTooltip || false;
    if (this.isTooltip) {
      this.divStyle = "position: absolute; top: -30px; left: 10px;";
      // Full size, but never larger than the window.
      this.imgStyle =
        "max-width: 60vw; max-height: 70vh; background: var(--p-surface-0, white); border: 1px solid var(--p-surface-300, #d1d5db); box-shadow: 0 4px 12px rgba(0,0,0,0.2);";
    } else {
      this.imgStyle = "height: 25px; position: relative; top: 4px";
    }
  }

  ngAfterViewInit() {
    if (this.image) {
      ImageFns.convertFileData([this.image]);
      ImageFns.generateUrls([this.image], this.sanitizer);
    }
  }

  // Instead, clear all urls when the grid component is destroyed
  // Otherwise, there are problems with images disappearing
  // ngOnDestroy(): void {
  //   ImageFns.clearUrls([this.image]);
  // }

  refresh(params?: object): boolean {
    return true;
  }
}
